import { BASE_URL } from "./ApiService";
import { LOCAL_STORAGE_KEY } from "../const/localstorageKey";
import UserService from "./UserService";
import axios from 'axios';

const AuthService = {
    login(credentials) {
        return axios.post(BASE_URL + '/login', credentials);
    },
    refreshAccessToken(refreshToken) {
        return new Promise((resolve, reject) => {
            axios.post(BASE_URL + '/token/refresh', {refresh_token: refreshToken}).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    getAccessToken() {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.TOKEN_KEY));
        return token.access_token;
    },
    getRefreshToken() {
        const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.TOKEN_KEY));
        return token.refresh_token;
    },
    saveToken(token) {
        return localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN_KEY, token);
    },
    getUserCurrentLogin() {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_CURRENT_LOGIN));
    },
    saveUserCurrentLogin(user) {
        return localStorage.setItem(LOCAL_STORAGE_KEY.USER_CURRENT_LOGIN, JSON.stringify(user));
    },
    getOrganizationId() {
        return localStorage.getItem(LOCAL_STORAGE_KEY.ORGANIZATION_ID);
    },
    saveOrganizationId(organizaion_id) {
        return localStorage.setItem(LOCAL_STORAGE_KEY.ORGANIZATION_ID, organizaion_id);
    },
    removeToken() {
        localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN_KEY);
        localStorage.removeItem(LOCAL_STORAGE_KEY.USER_CURRENT_LOGIN);
        return true;
    },
    getUserAfterUpdate(userId) {
        return new Promise((resolve, reject) => {
            UserService.getUserWithId(userId).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    }
};

export default AuthService
